module.exports = __webpack_public_path__ + "img/arrow_down.7c6bf430.svg";